import { Ogp } from "shared/features/utils";
import { NextPageWithLayout } from "shared/types";

import { StandardLayout } from "~/components/layouts";
import { AuthedRoute } from "~/features/auth";
import { CheckoutsPage } from "~/features/checkouts";

const Page: NextPageWithLayout = () => {
  return (
    <AuthedRoute>
      <Ogp title="購入履歴" />
      <CheckoutsPage />
    </AuthedRoute>
  );
};

Page.getLayout = (page) => (
  <StandardLayout>{page}</StandardLayout>
);

export default Page;
